import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appPreventLongDescriptions]',
  standalone: true,
})
export class PreventLongDescriptionsDirective {
  @Output() invalidDescriptionLength = new EventEmitter<string>();

  /**
   * Tope de caracteres de la descripción. Default 200 (no cambia el
   * comportamiento de otros módulos). Los catálogos de negocios lo suben a 500
   * con [descriptionMaxLength]="500" para coincidir con @Size(max = 500) del backend.
   */
  @Input() descriptionMaxLength = 200;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];
    if (allowedKeys.includes(event.key)) {
      return;
    }
    if (input.value.length >= this.descriptionMaxLength) {
      event.preventDefault();
      this.invalidDescriptionLength.emit(
        `La descripción no puede superar los ${this.descriptionMaxLength} caracteres`,
      );
    }
  }
}
